export default __webpack_public_path__ + "static/71-62260cea1bb66d13cdf0dc73a2aa2fde.gif";